import { NO_TEAM_COLOR, ownerTeamOf, relatedTeamsOf, type TeamColors, type Teamed } from './roadmapViewUtils';
import styles from './RoadmapV2.module.css';

interface Props {
  /** The initiative (or anything carrying `teams` plus the v9 owner / related
   * fields). One solid chip for the OWNING team, an outlined chip per RELATED
   * team: a team whose meeting raised the item has a stake, not the item
   * (owner ruling 2026-10-12). */
  of: Teamed;
  colors: TeamColors;
  /** The admin who pinned this assignment on /roadmap (kanban ae374351); when
   * set the tooltip credits them instead of Merlin. */
  pinnedBy?: string | null;
}

export function TeamTags({ of, colors, pinnedBy = null }: Props) {
  const owner = ownerTeamOf(of);
  const related = relatedTeamsOf(of);
  if (!owner && related.length === 0) return null;
  const how = pinnedBy
    ? `set by ${pinnedBy} on the roadmap page (kept on later runs)`
    : 'tagged by Merlin from the meetings it read';
  return (
    <>
      {owner && (
        <span
          className={styles.teamTag}
          style={{ background: colors[owner] ?? NO_TEAM_COLOR }}
          title={`Owning task force: ${owner} — ${how}`}
          data-testid="team-owner"
        >
          {owner}
        </span>
      )}
      {related.map((t) => (
        <span
          key={t}
          className={`${styles.teamTag} ${styles.teamTagRelated}`}
          style={{ borderColor: colors[t] ?? NO_TEAM_COLOR, color: colors[t] ?? NO_TEAM_COLOR }}
          title={
            owner
              ? `Related task force: ${t} — has a stake in this item but does not own it (${owner} does) — ${how}`
              : `Task force: ${t} — nobody has been named as the owner yet — ${how}`
          }
          data-testid="team-related"
        >
          {t}
        </span>
      ))}
    </>
  );
}
